import React from "react";
import "../components/doctorListTable.css";

const DoctorListTable = ({
  page,
  doctors,
  onEditDoctorClicked,
  onDeleteDoctorClicked,
}) => {
  const editDoctor = (doctor) => {
    onEditDoctorClicked(doctor);
  };

  const deleteDoctor = (doctor) => {
    onDeleteDoctorClicked(doctor);
  };

  return (
    <div className="doctor-specialist-table-container">
      <table className="doctor-specialist-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Nama Dokter</th>
            <th>Spesialisasi</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {doctors.length > 0 ? (
            doctors.map((doctor, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{doctor.doctor_name}</td>
                <td>{doctor.doctor_specialist.doctor_specialist_name}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editDoctor(doctor);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteDoctor(doctor);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DoctorListTable;
